import * as React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

export const Loader = () => {
	return <Player src="/lottie/cbx-loading-dots.json" autoplay={true} loop={true} />

}
